import { ChangeDetectionStrategy, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ENVIRONMENT_WEBSITE_TOKEN } from '@campus/environment';
import { ContactFormEntryInterface, PersonInterface } from '@campus/public-portal';
import { DcrAnimatedKai } from '@diekeure/dcr-components';
import { Observable, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HomePageViewModel } from './home-page.viewmodel';

@Component({
  standalone: false,
  selector: 'polpo-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HomePageViewModel],
})
export class HomePageComponent implements OnInit, OnDestroy {
  @ViewChild('kai') kai: ElementRef<DcrAnimatedKai>;
  @ViewChild('cta') cta: ElementRef<HTMLDivElement>;

  private subscriptions: Subscription = new Subscription();

  private vm = inject(HomePageViewModel);
  private environmentWebsite = inject(ENVIRONMENT_WEBSITE_TOKEN);

  public user$: Observable<PersonInterface>;
  public isMaintenanceMode$: Observable<boolean>;
  public contactSuccess$: Observable<boolean>;
  private title = inject(Title);

  public subjects = [
    'Ik wil een gratis opleiding over Polpo',
    'Ik wil een demo over Polpo',
    'Ik wil meer info over Polpo',
    'Ik heb een vraag over mijn bestelling',
    'Ik heb een technische vraag of probleem',
    'Ik wil een fout melden',
    'Ik heb een andere vraag',
  ];
  public statusPageUrl: string;

  ngOnInit() {
    this.title.setTitle('Polpo');
    this.contactSuccess$ = this.vm.contactSuccess$;

    this.user$ = this.vm.user$.pipe(shareReplay(1));

    this.isMaintenanceMode$ = this.vm.isMaintenanceMode$;
    this.statusPageUrl = this.environmentWebsite.statusPageUrl;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.cta?.nativeElement?.removeEventListener('mouseenter', this._wave.bind(this));
    this.cta?.nativeElement?.removeEventListener('mouseleave', this._idle.bind(this));
  }

  loadedKai(event: Event) {
    const el = this.cta?.nativeElement;
    if (el) {
      el.addEventListener('mouseenter', this._wave.bind(this));
      el.addEventListener('mouseleave', this._idle.bind(this));
    }
  }

  public goToPlatform() {
    this.vm.redirectToPlatform();
  }

  public contactFormSubmitted(formValues: ContactFormEntryInterface) {
    this.vm.sendContactForm(formValues);
  }

  private _wave() {
    this.kai?.nativeElement?.setState('WAVING');
  }
  private _idle() {
    this.kai?.nativeElement?.setState('IDLE');
  }
}
